import { type FC } from 'react';

import { SPOTLIGHT_MEDIA_QUERY } from 'constants/spotlight';
import { useScreenSize } from 'hooks/use-screen-size';

import { TopBar } from './TopBar';

export const TopBarWrapper: FC = () => {
  const { isCustomScreen } = useScreenSize({ minWidth: SPOTLIGHT_MEDIA_QUERY });

  if (isCustomScreen) {
    return <TopBar />;
  }

  return null;
};
